import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import { WITH_TRAVELCARD } from "./PaymentMethod";
import InputText from "../components/Form/InputText";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function PaymentWithTravelcard() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // Reset specific fields if the selected compensation is not WITH_TRAVELCARD
    useEffect(() => {
        if (formData.paymentmethod === WITH_TRAVELCARD) {
            setFormData((prev) => ({
                ...prev,
                ticketnumber: "",
                phonenumberapp: "",
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values, { setSubmitting, setErrors }) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/ersattning-for");
                }}
                initialValues={{
                    ...formData,

                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    cardnumber: Yup.string()
                        .required("Vänligen fyll i ditt kortnummer")
                        .min(12, "Kortnumret måste innehålla minst 12 siffror")
                        .matches(/^\d+$/, "Kortnumret får bara innehålla siffror")
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"40"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">
                                    Jag hade biljetten på ett reskort
                                </h2>

                                <p>
                                    För att gå vidare behöver vi ditt reskortsnummer. Det hittar du på kortets baksida.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="cardnumber"
                                    label={
                                        <>
                                            Mitt reskortsnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="number"
                                    autocomplete={"off"}
                                    moreinfo="12 Siffror "
                                    maxLength={12}
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
